<template>
    <div class="author">
        <div v-if="info.photo && !noPhoto" class="author-block">
            <picture class="author-logo" :class="{'author-logo-big': isBig}" v-if="info.images">
                <source :srcset="isBig ? `${info.images.webp['size-60']} 1x, ${info.images.webp['size-120']} 2x`: `${info.images.webp['size-30']} 1x, ${info.images.webp['size-60']} 2x`" type="image/webp">
                <source :srcset="isBig ? `${info.images.photo['size-60']} 1x, ${info.images.photo['size-120']} 2x`: `${info.images.photo['size-30']} 1x, ${info.images.photo['size-30']} 2x`" type="image/jpeg">
                <img :src="isBig ? info.images.photo['size-30'] : info.images.photo['size-60']" alt="logo" @error="setAltImg" loading="lazy" :width="isBig ? 48 : 28" :height="isBig ? 48 : 28">
            </picture>
            <img v-else :src="info.photo" alt="logo" class="author-logo" :class="{'author-logo-big': isBig}" @error="setAltImg" loading="lazy" :width="isBig ? 48 : 28" :height="isBig ? 48 : 28">
            <div class="author-sert" :class="{'author-sert-big': isBig}" v-if="info.name === 'CoTCCC'"><icon-sertificate/></div>
        </div>
        <div v-else class="author-logo -no-logo" :class="{'author-logo-big': isBig}">
            <IconUser/>
        </div>
   </div>
</template>

<script>
import IconUser from './icons/IconUser';
import IconSertificate from './icons/IconSertificate';

export default {
    name: "TestAuthor",
    props: ['info', 'isSert', 'isGridView', 'isBig'],
    data() {
        return {
            showTooltip: false,
            noPhoto: false
        }
    },
    methods: {
        setAltImg() {
            this.noPhoto = true
        },
    },
    components: {
        IconSertificate,
        IconUser
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/front/helpers";
.author {
    display: flex;
    position: relative;
    gap: 6px;
    margin: 3px 0;

    &-block {
        position: relative;
    }

    &-sert {
        background: #EEFFEE;
        border: 1px solid #FFFFFF;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        bottom: 0;

        svg {
            width: 8px;
            color: #3CC13B;
        }

        &-big {
            width: 20px;
            height: 20px;
        }
    }

    @include responsive-above($lg) {
        margin-right: 20px;
    }

    @include responsive-above($xs) {
        margin-right: 10px;
    }

    &:last-child {
        margin-right: 0;
    }

    &-logo {
        width: 28px;
        min-width: 28px;
        height: 28px;
        border-radius: 50%;
        overflow: hidden;
        display: block;
        border: solid 1px #F4F4F4;

        &:hover {
            border-color: $color-brand;
        }

        &-big {
            display: block;
            width: 48px;
            min-width: 48px;
            height: 48px;

            @include responsive-below($xs) {
                width: 40px;
                min-width: 40px;
                height: 40px;
            }
        }

        &.-no-logo {
            background-color: #EEF2F7;
            display: flex;
            align-items: center;
            justify-content: center;
            border: solid 1px #fff;
            padding: 3px;

            &:hover {
                border-color: $color-brand;
            }
        }

        img {
            object-fit: contain;
            object-position: center;
            height: 100%;
            width: 100%;
        }

        svg {
            max-width: 100%;
            max-height: 100%;
        }
    }
}
</style>
